module.exports = __webpack_public_path__ + "assets/db6b632927c66a93da641c97c20701ef.png";